import Swal from "sweetalert2";

export const AlertMessage = (title, text, icon) => {
  return Swal.fire({
    title,
    html: text,
    icon,
    confirmButtonColor: "#7de2a5",
  });
};

export const AlertTimer = (
  title,
  icon = "success",
  position = "top-end",
  timer = 3000
) => {
  const Toast = Swal.mixin({
    toast: true,
    position,
    showConfirmButton: false,
    timer,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });
  Toast.fire({
    icon,
    title,
  });
  return Toast;
};
